module.exports =
    defaults: require 'lodash/object/defaults'
    extend: require 'lodash/object/extend'
    isFunction: require 'lodash/lang/isFunction'
    filter: require 'lodash/collection/filter'



/** WEBPACK FOOTER **
 ** ./src/Lodash.coffee
 **/